/**
 * Gemeinsame Regel fuer alle Tastenkuerzel im Spiel.
 *
 * Im Spiel liegen Tastenkuerzel auf einzelnen Buchstaben und Ziffern: WASD
 * laeuft, 1/2/3/R wirken Skills, B/N/K/O/F/G/V oeffnen Fenster. Sie haengen
 * am Fenster, damit sie ueberall gelten - und genau das wurde zum Problem:
 *
 * Rueckmeldung aus dem Spiel (25.09.2026): Im Feld fuer den Matchcode liessen
 * sich mehrere Zeichen nicht eintippen. Sie wurden von den Kuerzeln
 * abgefangen, bevor das Eingabefeld sie sehen konnte.
 *
 * Deshalb gilt ab jetzt: Wer tippt, tippt. Solange der Finger in einem
 * Eingabefeld ist, sind alle Kuerzel aus.
 */

/** Liegt der Tastendruck in einem Feld, in das man schreiben kann? */
export function isTypingTarget(target: EventTarget | null): boolean {
  /*
   * Geprueft wird an den Merkmalen, nicht mit "instanceof HTMLElement".
   *
   * So laesst sich die Regel ohne Browser pruefen - im Testlauf gibt es kein
   * DOM, und die Regel selbst ist zu wichtig, um ungeprueft zu bleiben.
   */
  const element = target as { tagName?: unknown; isContentEditable?: unknown } | null;
  if (!element) return false;

  const name = typeof element.tagName === 'string' ? element.tagName.toUpperCase() : '';
  if (name === 'INPUT' || name === 'TEXTAREA' || name === 'SELECT') return true;

  // Auch frei beschreibbare Bereiche zaehlen dazu.
  return element.isContentEditable === true;
}

/**
 * Soll dieser Tastendruck ein Kuerzel ausloesen?
 *
 * Nein, wenn gerade geschrieben wird - und auch nicht, wenn eine Modifiertaste
 * gehalten wird: Strg+R laedt die Seite neu, das darf kein Skill abfangen.
 */
export function shouldHandleShortcut(event: KeyboardEvent): boolean {
  if (event.ctrlKey || event.metaKey || event.altKey) return false;
  return !isTypingTarget(event.target);
}
